import { ChipModelState } from '@/shared/components/ui';
import { EstadosActualizacionCompatibilityContratoEnum, EstadosActualizacionContratoEnum } from '@/shared/interfaces';

export type DataContractStateChipProps = {
  statusData: string;
};

type TypeColors = "primary" | "secondary" | "warning" | "error" | "info" | "success" | undefined;


const DataContractStateChip: React.FC<DataContractStateChipProps> = ({
  statusData
}) => {
  let colorChoosen : TypeColors;
  statusData==EstadosActualizacionContratoEnum.SOLICITUD_CORRECCION?
  colorChoosen="error"
  :
  statusData==EstadosActualizacionContratoEnum.CORREGIDO?
  colorChoosen="info"
  :
  statusData==EstadosActualizacionContratoEnum.REVISADO?
  colorChoosen="success"
  :colorChoosen="warning"
  ;

  // if (!statusData || !contractState) return 'N/A';

  return (
    <>
      <ChipModelState
        label={
          statusData==EstadosActualizacionContratoEnum.ACTUALIZADO?
            EstadosActualizacionCompatibilityContratoEnum.PENDIENTE_REVISION
          :statusData==EstadosActualizacionContratoEnum.REVISADO?
            EstadosActualizacionCompatibilityContratoEnum.APROBADO
          :statusData
        }
        color={colorChoosen}
        sxChip={{
          width: "70%",
          textAlign: 'center',
          py: 2,
          // px: 3,
          fontWeight: 500,
          fontSize: '14px',
        }}
      />
    </>
  );
};

export default DataContractStateChip;
